export const enum SpotPriceActionTypes {
    SET_USER_SPOT_PRICE_DATA = 'SET_USER_SPOT_PRICE_DATA',
}
